export default __webpack_public_path__ + "static/media/couple_1.04a28c6b.jpg";